import React, { useState, useEffect } from 'react';
import { DateRangePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';
import TextField from '@mui/material/TextField';
import { SingleInputDateRangeField } from '@mui/x-date-pickers-pro/SingleInputDateRangeField';
import dayjs from 'dayjs';

const DateRangePickerComponent = ({ selectedDate, handleDateChange }) => {
  const today = dayjs();

  // Initialize with proper default values if selectedDate is null or invalid
  const [internalDateRange, setInternalDateRange] = useState(() => {
    if (selectedDate && Array.isArray(selectedDate) && selectedDate.length === 2) {
      return [
        selectedDate[0] ? dayjs(selectedDate[0]) : null,
        selectedDate[1] ? dayjs(selectedDate[1]) : null,
      ];
    }
    return [null, null];
  });

  // Update internal state when selectedDate prop changes
  useEffect(() => {
    if (selectedDate && Array.isArray(selectedDate) && selectedDate.length === 2) {
      setInternalDateRange([
        selectedDate[0] ? dayjs(selectedDate[0]) : null,
        selectedDate[1] ? dayjs(selectedDate[1]) : null,
      ]);
    }
  }, [selectedDate]);

  const handleDateRangeChange = (newValue) => {
    try {
      // Ensure we have valid dayjs objects
      const normalizedValue = [
        newValue && newValue[0] ? dayjs(newValue[0]) : null,
        newValue && newValue[1] ? dayjs(newValue[1]) : null,
      ];

      setInternalDateRange(normalizedValue);

      // Only call handleDateChange if we have a valid callback and valid dates
      if (handleDateChange && typeof handleDateChange === 'function') {
        handleDateChange(normalizedValue);
      }
    } catch (error) {
      console.error('Error handling date range change:', error);
    }
  };

  return (
    <DateRangePicker
      value={internalDateRange}
      onChange={handleDateRangeChange}
      slots={{ field: SingleInputDateRangeField }}
      data-testid="daterange-picker-component-1"
      id="daterange-picker-component-1"
      slotProps={{
        textField: {
          fullWidth: true,
          size: 'small',
          placeholder: 'Select Date Range',
          InputLabelProps: {
            shrink: false,
            style: { display: 'none' },
          },
          sx: {
            height: 44,
            '& .MuiInputBase-root': { height: 44 },
            '& .MuiInputLabel-root': {
              display: 'none !important',
            },
            '& .MuiInputLabel-shrink': {
              display: 'none !important',
            },
            '& .MuiInputBase-input::placeholder': {
              opacity: 1,
              color: '#757575',
            },
          },
        },
      }}
      maxDate={today}
    />
  );
};

export default DateRangePickerComponent;
